require('./bootstrap');
require('intersection-observer');
import { data } from 'jquery';

import Vue from 'vue';


Vue.component('secteur-comp-info', require('./components/InfoSecteurComponent.vue').default);


const app = new Vue({
    el: '#app',
});